import axios from 'axios';

export class LoadAsset {
  public type;
  public url;

  public groupType?: string;

  public result?: any;
  public error?: Error;

  constructor({type, url}: {type: string; url: string}) {
    this.type = type;
    this.url = url;
  }

  load = async () => {
    try {
      const {data} = await axios.get(this.url, {withCredentials: true});
      this.result = data;
    } catch (error) {
      this.error = error;
    }
  };
}
